import { render, staticRenderFns } from "./BeServiceAccordion.vue?vue&type=template&id=4657350a&scoped=true"
import script from "./BeServiceAccordion.vue?vue&type=script&lang=js"
export * from "./BeServiceAccordion.vue?vue&type=script&lang=js"
import style0 from "./BeServiceAccordion.vue?vue&type=style&index=0&id=4657350a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4657350a",
  null
  
)

export default component.exports